import React from "react";
import { SolutionCardList } from "../solutions/SolutionCardList";
import { Box, Typography } from "@material-ui/core";
import { injectIntl, defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "solution.step.title",
    defaultMessage:
      "Which Edenred solutions do you want to add or edit vehicles in?",
  },
  subtitle: {
    id: "solution.step.subtitle",
    defaultMessage: "A single upload will be made for all selected platforms.",
  },
  gohubSolutionName: {
    id: "solution.step.gohub.name",
    defaultMessage: "GoHub",
  },
  gohubSolutionDescription: {
    id: "solution.step.gohub.description",
    defaultMessage:
      "Remains selected by default. Add Edenred solutions to sync the upload across other platforms.",
  },
});

export class SolutionStepBase extends React.Component {
  state = {
    solutions: [],
  };

  componentDidMount() {
    const defaultSolution =
      this.props.includeDefaultSolution !== false
        ? [
            {
              icon: "sync",
              code: 1,
              isMain: true,
              companyHasSolution: true,
            },
          ]
        : [];

    this.props
      .getSolutions()
      .then((solutions) =>
        this.setState({
          solutions: [
            ...defaultSolution,
            ...(Array.isArray(solutions)
              ? solutions.filter((solution) => solution?.companyHasSolution)
              : []),
          ],
        }),
      )
      .catch(console.error);
  }

  getSolutionsWithI18n() {
    const { intl } = this.props;

    return this.state.solutions.map((solution) => {
      if (solution.isMain) {
        return {
          ...solution,
          name: intl.formatMessage(messages.gohubSolutionName),
          description: intl.formatMessage(messages.gohubSolutionDescription),
        };
      }
      return solution;
    });
  }

  getTitleI18n() {
    const { intl, title } = this.props;

    return title || intl.formatMessage(messages.title);
  }

  getSubtitleI18n() {
    const { intl, subtitle } = this.props;

    return subtitle === null
      ? null
      : subtitle || intl.formatMessage(messages.subtitle);
  }
}

export class SolutionStep extends SolutionStepBase {
  render() {
    const { intl, activeSolutions } = this.props;

    // Use props customizados ou fallback para mensagens default
    const displayTitle = this.getTitleI18n();
    // subtitle undefined = set default, subtitle null = does not show subtitle
    const displaySubtitle = this.getSubtitleI18n();

    const solutionsWithI18n = this.getSolutionsWithI18n(intl);

    return (
      <Box sx={{ margin: "2.5rem 0" }}>
        <Box sx={{ textAlign: "left", paddingBottom: "2rem" }}>
          <Typography
            style={{
              fontWeight: 500,
              color: "#1E293B",
              fontFamily: "'Ubuntu', Arial, sans-serif",
              fontSize: "20px",
            }}
          >
            {displayTitle}
          </Typography>
          {displaySubtitle && (
            <Typography
              style={{
                fontWeight: 400,
                color: "#525866",
                fontFamily: "'Ubuntu', Arial, sans-serif",
                fontSize: "14px",
              }}
            >
              {displaySubtitle}
            </Typography>
          )}
        </Box>
        <SolutionCardList
          cards={solutionsWithI18n}
          solutionsSelected={this.props.solutionsSelected}
          solutionsCodesSelected={this.props.solutionsCodesSelected}
          getSolutionsCodes={this.props.getSolutionsCodes}
          onSolutionsCodesChanges={this.props.onSolutionsCodesChanges}
          onSolutionToggle={this.props.onSolutionToggle}
          activeSolutions={activeSolutions}
        />
      </Box>
    );
  }
}

export default injectIntl(SolutionStep);
